export class BlobResponse {
    blob: Blob;
    filename?: string;
    constructor(blobResponse: BlobResponse) {
        this.blob = blobResponse.blob;
        this.filename = blobResponse.filename;
    }
}